module.exports = __webpack_public_path__ + "img/orderpack.721538e1.png";